/**
 * Whether this person has dismissed the welcome overlay. Once per person in this browser, kept in
 * localStorage so a new tab or a new session does not show it again. Storage that is blocked or
 * missing (a private window, a locked-down profile) counts as not seen and never throws.
 */
const PREFIX = "welcomeSeen";

function keyFor(subject: string | null | undefined): string {
  return subject ? `${PREFIX}:${subject.toLowerCase()}` : PREFIX;
}

function store(): Storage | null {
  try {
    return typeof localStorage === "undefined" ? null : localStorage;
  } catch {
    return null;
  }
}

export function welcomeSeen(subject: string | null | undefined): boolean {
  try {
    return store()?.getItem(keyFor(subject)) === "1";
  } catch {
    return false;
  }
}

export function markWelcomeSeen(subject: string | null | undefined): void {
  try {
    store()?.setItem(keyFor(subject), "1");
  } catch {
    // Not remembered; the overlay shows again next time, which is the safe failure.
  }
}
